import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'first-page', component: () => import('@/pages/PagePage.vue') },
    { path: '/pages', name: 'pages', component: () => import('@/pages/PagesPage.vue') },
    { path: '/pages/create', name: 'page-create', component: () => import('@/pages/PageCreatePage.vue') },
    { path: '/pages/:id/edit', name: 'page-edit', component: () => import('@/pages/PageCreatePage.vue') },
    {
      path: '/pages/:id',
      name: 'page',
      component: () => import('@/pages/PagePage.vue'),
      beforeEnter: (to) => (to.query.dialog === 'settings' ? { path: `/pages/${String(to.params.id)}/edit` } : true),
    },
    { path: '/views', name: 'views', component: () => import('@/pages/ViewsPage.vue') },
    { path: '/views/create', name: 'view-create', component: () => import('@/pages/ViewCreatePage.vue') },
    { path: '/views/:id', name: 'view', component: () => import('@/pages/ViewCreatePage.vue') },
    { path: '/sources', name: 'sources', component: () => import('@/pages/SourcesPage.vue') },
    { path: '/sources/create', name: 'source-create', component: () => import('@/pages/SourceCreatePage.vue') },
    { path: '/sources/:id', name: 'source', component: () => import('@/pages/SourceCreatePage.vue') },
    { path: '/streams', name: 'log-streams', component: () => import('@/pages/StreamsPage.vue') },
    { path: '/streams/:id', name: 'log-stream', component: () => import('@/pages/LogStreamPage.vue') },
    { path: '/telemetry', name: 'telemetry', component: () => import('@/pages/TelemetryPage.vue') },
    { path: '/alerts', name: 'alerts', component: () => import('@/pages/AlertsPage.vue') },
    { path: '/welcome', name: 'welcome', component: () => import('@/pages/WelcomePage.vue') },
    { path: '/annotations', name: 'annotations', component: () => import('@/pages/AnnotationsPage.vue') },
    { path: '/notifications', name: 'notifications', component: () => import('@/pages/NotificationsPage.vue') },
    { path: '/settings', name: 'settings', component: () => import('@/pages/SettingsPage.vue') },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

const staleChunk = /dynamically imported module|Importing a module script failed|module script failed|MIME type/i

router.onError((error, to) => {
  const message = error instanceof Error ? error.message : String(error)
  if (!staleChunk.test(message)) return
  const key = `router:reload:${to.fullPath}`
  if (sessionStorage.getItem(key)) return
  sessionStorage.setItem(key, '1')
  window.location.assign(to.fullPath)
})

router.afterEach((to) => {
  sessionStorage.removeItem(`router:reload:${to.fullPath}`)
})

export default router
